<template lang="pug">
.radio-select
  el-row(style="width:100%")
    el-col(:span="4" :class="required?'required':''") {{ $t('选择供应商') }}
    el-col(:span="20")
      el-radio-group.radio-group(v-if='data.length' v-model="activeIndex" @change="$emit('onChange', activeIndex)")
        el-radio.radio-item(v-for="(item, i) in data" :key="'data' + i" :label="item.vendor_id" :disabled="!item.is_quoted || item.purchase_status === 1 || item.status === 0") {{item.vendor_name}}
          span(v-if="item.group_select_status !== ''" style="margin-left:10px") ({{ $t(item.group_select_status) }})
</template>

<script>
import TitleBar from '@/components/TitleBar'

export default {
  props: {
    required: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    defaultIndex: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      activeIndex: -1
    }
  },
  mounted () {
    this.activeIndex = this.defaultIndex
  },
  components: {
    TitleBar
  }
}
</script>

<style lang="stylus">
.radio-select
  .radio-item
    display block
    margin 0 0 20px
    &:last-child
      margin-bottom 0
</style>
